<template>
  <div>
    <v-dialog
      v-model="dialog"
      transition="dialog-bottom-transition"
      persistent
      max-width="700"
    >
      <!--begin::Modal dialog-->
      <v-card class="poppins">
        <v-card-title
          class="d-flex justify-content-between h-65px border-bottom"
        >
          <h4 class="mb-0 font-weight-bolder">Update License</h4>
          <div
            class="btn btn-sm btn-icon btn-active-light-info"
            @click="toggleModal"
          >
            <span class="svg-icon">
              <v-icon size="22">mdi-close</v-icon>
            </span>
          </div>
        </v-card-title>
        <v-card-text>
          <v-container class="py-0">
            <!--            <v-card class="p-5 sellers-tab-card">-->
            <v-card flat class="d-flex flex-column elevation-0">
              <div class="d-flex flex-column flex-fill">
                <!-- Basic fields starts -->
                <v-container class="d-flex flex-column flex-fill">
                  <v-row>
                    <v-col cols="12">
                      <DatepickerContainer label="License expiry date">
                        <SingleDatepicker
                          position="left"
                          :value="formData.license_expiry_date"
                          :clearDate="() => cleardate('license_expiry_date')"
                          @on-submit="
                            (date) => getDateRange(date, 'license_expiry_date')
                          "
                          class="poppins"
                          :max-date="null"
                        />
                      </DatepickerContainer>

                      <FieldContainer label="MRSAL code">
                        <v-text-field
                          v-model="formData.mrsal_code"
                          clearable
                          dense
                          outlined
                          hide-details
                          class="rounded-lg"
                        />
                      </FieldContainer>

                      <FieldContainer
                        label="MRSAL entity"
                        v-if="
                          formData.mrsal_code !== null &&
                          formData.mrsal_code !== '' &&
                          formData.mrsal_code !== undefined
                        "
                      >
                        <v-text-field
                          v-model="formData.mrsal_entity"
                          clearable
                          dense
                          outlined
                          hide-details
                          class="rounded-lg"
                        />
                      </FieldContainer>

                      <DatepickerContainer
                        label="MRSAL expiry"
                        v-if="
                          formData.mrsal_code !== null &&
                          formData.mrsal_code !== '' &&
                          formData.mrsal_code !== undefined
                        "
                      >
                        <SingleDatepicker
                          position="left"
                          :value="formData.mrsal_expiry"
                          :clearDate="() => cleardate('mrsal_expiry')"
                          @on-submit="
                            (date) => getDateRange(date, 'mrsal_expiry')
                          "
                          class="poppins"
                          :max-date="null"
                        />
                      </DatepickerContainer>

                      <FieldContainer label="Import/Export Activity Allowed">
                        <v-switch
                          class="h-55px"
                          v-model="formData.is_import_export_activity_allowed"
                          inset
                          dense
                          :true-value="1"
                          :false-value="0"
                        />
                      </FieldContainer>
                    </v-col>
                  </v-row>

                  <v-row class="mt-10 mb-16">
                    <v-col cols="12" class="pr-0">
                      <v-row class="d-flex justify-content-end">
                        <v-col cols="auto">
                          <button
                            @click="submit"
                            type="submit"
                            class="btn btn-info ls1 px-5 py-3"
                          >
                            Submit
                          </button>
                        </v-col>
                      </v-row></v-col
                    ></v-row
                  >
                </v-container>
                <!-- Basic fields ends -->
              </div>
            </v-card>
            <!--            </v-card>-->
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
      <!--end::Modal dialog-->
    </v-dialog>
  </div>
</template>

<script>
import Swal from "sweetalert2";
import { SET_PAGE_LOADING } from "@/core/services/store/config.module";
import ApiService from "@/core/services/api.service";
// import { required, email, numeric, requiredIf } from "vuelidate/lib/validators";
// import fieldValueValidation from "@/own/mixins/fieldValueValidation.js";
// import validationMixin from "@/own/mixins/validationMixin.js";

import FieldContainer from "@/own/components/customers/clients/FormParts/FieldContainer.vue";
import DatepickerContainer from "@/own/components/customers/clients/FormParts/DatepickerContainer.vue";
import SingleDatepicker from "@/own/components/SingleDatepicker.vue";

export default {
  name: "UpdateLicense",
  props: ["refresher"],
  // mixins: [validationMixin, fieldValueValidation],
  components: { FieldContainer, SingleDatepicker, DatepickerContainer },
  data: () => ({
    dialog: false,
    // serverData: null,
    formData: {
      license_expiry_date: null,
      mrsal_code: null,
      mrsal_entity: null,
      mrsal_expiry: null,
      is_import_export_activity_allowed: null,
    },
  }),
  methods: {
    getDateRange(date, field) {
      if (date && field) {
        this.formData[field] = date[0];
      }
    },
    cleardate(field) {
      if (field) {
        this.formData[field] = null;
      }
    },
    loadDataFromServer() {
      this.pageLoader(true);
      ApiService.post("/authorizations/clients/get_customer_license_data", {
        id: this.$store.getters.getItemForAction.id,
      })
        .then(({ data }) => {
          if (data.success) {
            this.formData = { ...data.data };
          }
        })
        .finally(() => {
          this.pageLoader(false);
        });
    },
    submit() {
      this.pageLoader(true);
      let data = {
        ...this.formData,
        id: this.$store.getters.getItemForAction.id,
      };
      ApiService.post("/authorizations/clients/customer_license_update", data)
        .then(() => {
          Swal.fire({
            title: "Updated",
            text: `License data has been updated.`,
            icon: "success",
            showConfirmButton: false,
            timer: 2500,
          });
          this.toggleModal();
          this.resetForm();
          this.pageLoader(false);
        })
        .catch(() => {
          this.pageLoader(false);
        });
    },
    /**
     * reset data to intial value
     */
    resetForm() {
      this.formData = {
        license_expiry_date: null,
        mrsal_code: null,
        mrsal_entity: null,
        mrsal_expiry: null,
        is_import_export_activity_allowed: null,
      };
    },
    toggleModal() {
      if (this.dialog) {
        this.resetForm();
      } else {
        this.loadDataFromServer();
      }
      this.dialog = !this.dialog;
    },
    pageLoader(state) {
      this.$store.commit(SET_PAGE_LOADING, state);
    },
  },
  computed: {
    // isDataLoaded: function () {
    //   return !!this.serverData;
    // },
  },
};
</script>
